import React from 'react';
import { motion } from 'framer-motion';

const SectionHeading = ({ children }) => (
  <h2 className="text-3xl font-serif font-semibold text-brown-deep mt-12 mb-6">{children}</h2>
);

const AboutBio = () => (
  <motion.div
    initial={{ opacity: 0, x: -30 }}
    animate={{ opacity: 1, x: 0 }}
    transition={{ delay: 0.2, duration: 0.8 }}
    className="md:col-span-8 space-y-8"
  >
    <div className="mb-12">
      <img
        src="https://customer-assets.emergentagent.com/job_literary-zara/artifacts/bxks6fjm_headshot.JPG"
        alt="Zara Miller"
        className="w-64 h-64 object-cover rounded-2xl shadow-soft mb-8"
      />
    </div>

    <div className="prose prose-lg max-w-none">
      <p className="text-lg leading-relaxed text-brown-warm" data-testid="about-intro">
        <span className="text-2xl font-serif text-brown-deep float-left mr-2 leading-none mt-1">Z</span>
        ara Miller is an Amazon best-selling author whose work bridges fiction, journalism, and cultural commentary.
        As the author of the YA novel <em className="font-serif">I Am Cecilia</em>, and writer and co-director of the radio drama
        <em className="font-serif"> Midnight Express</em>, she brings a multidisciplinary approach to storytelling that resonates across formats.
      </p>

      <SectionHeading>Editorial & Journalistic Work</SectionHeading>
      <p className="text-lg leading-relaxed text-brown-warm">
        Zara serves as Editorial Assistant for <strong>Teen Magazine</strong>, a Harvard-led worldwide publication where she has written
        extensively on film, television, and cultural topics, while also conducting in-depth interviews with artists including The Band Light.
        She has also contributed to <strong>Georgetown University's Creator Institute</strong> and worked as a Publishing and Media Specialist
        at <strong>Manuscripts LLC</strong>, where she honed her expertise in editorial content strategy and media production.
      </p>

      <SectionHeading>Literary Accomplishments</SectionHeading>
      <p className="text-lg leading-relaxed text-brown-deep">
        Her literary work has been published in journals such as <em className="font-serif">Tint</em> and <em className="font-serif">Synchronized Chaos</em>.
        She is the creator of the anthology series <em className="font-serif">The Relatable Voices</em>, which was featured in the <strong>Washington Mail</strong>,
        and has contributed to international anthologies including a collection published by <strong>Ellie&Jay Publishing</strong> in the UK.
      </p>
      <p className="text-lg leading-relaxed text-brown-deep">
        Zara is endorsed by the <strong>National Writers Union</strong> and has been recognized in <strong>Who's Who in America</strong> and
        <strong> Who's Who in the World</strong> for her contributions to literature and media.
      </p>

      <SectionHeading>International Background</SectionHeading>
      <p className="text-lg leading-relaxed text-brown-deep">
        Born with a global perspective, Zara studied political science at <strong>Middlesex University</strong> and has lived in Prague, London,
        and Washington, DC. Her travels across Europe, Northern Africa, and Turkey have deeply informed her cultural analysis and narrative voice.
        Before dedicating herself fully to writing, she worked in London at <strong>Harrods</strong> as a makeup artist for luxury brands
        <strong> Chanel</strong> and <strong>Dior</strong>, an experience that sharpened her eye for aesthetics, storytelling through image, and brand narrative.
      </p>

      <SectionHeading>A Distinct Voice</SectionHeading>
      <p className="text-lg leading-relaxed text-brown-deep">
        What sets Zara apart is her ability to merge literary craft with cultural commentary, sharp editorial insight, and an understanding of
        media that spans journalism, fiction, and audio storytelling. She writes with authority, wit, and emotional intelligence—qualities that
        make her a compelling collaborator for publishers, media outlets, and creative projects.
      </p>
    </div>
  </motion.div>
);

export default AboutBio;
